import React, { useEffect, useState, useRef } from "react";
import ClientLayout from "../components/layout/ClientLayout";
import DatePickerComponent from "../components/DatePickerComponent";
import axiosInstance from "../../../utils/axiosInstance";
import { useNavigate, Link } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setLoader } from "../../../store/loaderSlice";
import ReactDOM1 from "react-dom/client";
import BetDetailsPopup from "./BetDetailsPopup";
import Bootstrap4DatePickerComponent from "../components/Bootstrap4DatePickerComponent";
import $ from "jquery";
import { isMobile } from "react-device-detect";

const ProfitLoss = () => {
  const tableRef = useRef(null);

  const dispatch = useDispatch();

  //const [selectedFromDate, setSelectedFromDate] = useState(todayStart);
  //const [selectedToDate, setSelectedToDate] = useState(todayEnd);
  const [profitLossList, setProfitLossList] = useState([]);
  const [viewPLDetails, setViewPLDetails] = useState(false);

  const [cricektPL, setCricektPL] = useState(0);
  const [fancyPL, setFancyPL] = useState(0);
  const [soccerPL, setSoccerPL] = useState(0);
  const [tennisPL, setTennisPL] = useState(0);
  const [horseRacePL, setHorseRacePL] = useState(0);
  const [grayHoundPL, setGrayHoundPL] = useState(0);
  const [worldCasinoPL, setWorldCasinoPL] = useState(0);
  const [betfairGamesPL, setBetfairGamesPL] = useState(0);
  const [galexyStudioPL, setGalexyStudioPL] = useState(0);
  const [tpStudioPL, setTpStudioPL] = useState(0);
  const [grandTotalPL, setGrandTotalPL] = useState(0);
  const [displayHeading, setDisplayHeading] = useState("Event Name");
  let username = "";
  const userInfo = useSelector((state) => state.userStore);
  if (
    userInfo !== null &&
    userInfo !== undefined &&
    userInfo.data !== null &&
    userInfo.data !== undefined
  ) {
    username = userInfo.data.uname;
  }

  const destroyDataTable = () => {
    const el = tableRef.current;
    if (el && $.fn.dataTable.isDataTable(el)) {
      $(el).off("click", ".toggle-row");
      $(el).DataTable().destroy();
    }
  };

  function toLocalString(d) {
    const pad = (x) => String(x).padStart(2, "0");
    return (
      `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
      `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    );
  }

  const getProfitLoss = async () => {
    try {
      setProfitLossList([]);
      setViewPLDetails(false);
      let resultObj = {};
      await dispatch(setLoader(true));

      //let frm = toLocalString(selectedFromDate);
      //let til = toLocalString(selectedToDate);

      let frm = toLocalString(startDate);
      let til = toLocalString(endDate);

      resultObj.fromdate = frm;
      resultObj.todate = til;

      const response = await axiosInstance.post("/profit-loss", resultObj);
      let results = response.data;
      if (results !== null && results !== undefined) {
        let returnObj = results.returnObj;

        setCricektPL(returnObj.cricket);
        setFancyPL(returnObj.fancy);
        setSoccerPL(returnObj.soccer);
        setTennisPL(returnObj.tennis);
        setHorseRacePL(returnObj.horseRace);
        setGrayHoundPL(returnObj.greyhound);
        setWorldCasinoPL(returnObj.worldCasino);
        setBetfairGamesPL(returnObj.betfairGames);
        setGalexyStudioPL(returnObj.galexyStudio);
        setTpStudioPL(returnObj.tpStudio);
        setGrandTotalPL(returnObj.grandTotal);
        await dispatch(setLoader(false));
      } else {
        await dispatch(setLoader(false));
      }
    } catch (error) {
      await dispatch(setLoader(false));
    }
  };

  const getSportDetail = async (sportsType, marketId) => {
    try {
      //let frm = toLocalString(selectedFromDate);
      //let til = toLocalString(selectedToDate);

      let frm = toLocalString(startDate);
      let til = toLocalString(endDate);

      if (sportsType == 1) {
        setDisplayHeading("Cricket");
      } else if (sportsType == 2) {
        setDisplayHeading("Soccer");
      } else if (sportsType == 3) {
        setDisplayHeading("Tennis");
      } else if (sportsType == 4) {
        setDisplayHeading("Horse Race");
      } else if (sportsType == 5) {
        setDisplayHeading("Greyhound");
      } else if (sportsType == 6) {
        setDisplayHeading("Casino");
      } else if (sportsType == 7) {
        setDisplayHeading("Teenpati Studio");
      } else if (sportsType == 9) {
        setDisplayHeading("Betfair Studio");
      } else if (sportsType == 10) {
        setDisplayHeading("Galaxy Casino");
      }

      await dispatch(setLoader(true));
      let resultObj = {};
      resultObj.sportsType = sportsType;
      resultObj.marketId = marketId;
      resultObj.fromdate = frm;
      resultObj.todate = til;

      const response = await axiosInstance.post(
        "/profit-loss/pl-details",
        resultObj
      );
      let results = response.data;
      if (results !== null && results !== undefined) {
        destroyDataTable();
        setProfitLossList(results.list);
        setViewPLDetails(true);
        await dispatch(setLoader(false));
      } else {
        await dispatch(setLoader(false));
      }
    } catch (error) {
      destroyDataTable();
      await dispatch(setLoader(false));
    }
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  useEffect(() => {
    const el = tableRef.current;
    if (!el) return;
    const $table = $(el);

    if (!profitLossList.length) return;

    let resizeHandler = null;

    const timerId = setTimeout(() => {
      const dt = $table.DataTable({
        paging: false,
        searching: false,
        info: false,
        autoWidth: false,
        ordering: true,
        responsive: { details: false }, // IMPORTANT — disable default details
        orderClasses: false,
        columnDefs: [
          { targets: 0, orderable: false } // first column NOT sortable
        ]
      });

      // ============ CUSTOM RESPONSIVE (ACCOUNT STATEMENT STYLE) ============

      // Find hidden columns for a row
      const getHiddenCols = (tr) => {
        const hidden = [];
        $(tr)
          .find("td")
          .each((i, td) => {
            if ($(td).css("display") === "none") hidden.push(i);
          });
        return hidden;
      };

      // Build details table for hidden columns
      const buildDetails = (tr) => {
        const thead = $table.find("thead th");
        const hidden = getHiddenCols(tr);

        if (!hidden.length) return "";

        let html = "";
        hidden.forEach((i) => {
          const head = $(thead[i]).text();
          const val = $(tr).find("td").eq(i).html();

          html += `
            <tr>
              <td style="border:none; border-bottom:1px solid #eee; padding:6px;">
                <strong>${head}</strong> ${val}
              </td>
            </tr>`;
        });

        return html;
      };

      // Insert toggle button in first column
      dt.rows().every(function () {
        const tr = $(this.node());
        const first = tr.find("td").eq(0);

        if (!first.find(".toggle-row").length) {
          first.prepend(
            `<button type="button" class="toggle-row toggle-closed">+</button> `
          );
        }
      });

      // Toggle click
      $table.on("click", ".toggle-row", function () {
        const tr = $(this).closest("tr");
        const row = dt.row(tr);

        const hidden = getHiddenCols(tr);
        if (!hidden.length) return;

        if (row.child.isShown()) {
          row.child.hide();
          tr.removeClass("shown");
          $(this)
            .text("+")
            .removeClass("toggle-open")
            .addClass("toggle-closed");
        } else {
          const html = buildDetails(tr);
          row
            .child(`<table class="table table-sm mb-0">${html}</table>`)
            .show();
          tr.addClass("shown");
          $(this)
            .text("−")
            .removeClass("toggle-closed")
            .addClass("toggle-open");
        }
      });

      // On window resize, adjust visibility
      resizeHandler = () => {
        dt.columns.adjust();
        dt.responsive.recalc();

        dt.rows().every(function () {
          const tr = $(this.node());
          const btn = tr.find(".toggle-row");
          const hidden = getHiddenCols(tr);

          if (hidden.length) btn.show();
          else btn.hide();
        });
      };

      window.addEventListener("resize", resizeHandler);
      resizeHandler();
    }, 50);

    // Cleanup: destroy DataTable, remove listeners
    return () => {
      clearTimeout(timerId);
      if (resizeHandler) {
        window.removeEventListener("resize", resizeHandler);
      }
      destroyDataTable();
    };
  }, [profitLossList]);

  const openLedgerPopUp = async (id, game_type) => {
    if (game_type == 9) {
      const popup = window.open(
        "/client-virtual-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    } else if (game_type == 7 || game_type == 10) {
      const popup = window.open(
        "/client-tp-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    } else {
      const popup = window.open(
        "/clinet-bet-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    }
  };

  const showBetDetails = async (row) => {
    openLedgerPopUp(row.id, row.game_type);
  };

  const showEventName = (eventTxt) => {
    return eventTxt;
  };

  const showDescription = (marketType) => {
    let marketTypeTxt = "";
    if (marketType == 2) {
      marketTypeTxt = "/Bookmaker";
    } else if (marketType == 1) {
      marketTypeTxt = "/Match Odd";
    } else if (marketType == 5) {
      marketTypeTxt = "/Tie";
    } else if (marketType == 6) {
      marketTypeTxt = "/Figure";
    } else if (marketType == 8) {
      marketTypeTxt = "/EvenOdd";
    }

    return marketTypeTxt;
  };

  const today = new Date();
  const year = today.getFullYear();
  const monthIndex = today.getMonth(); // 0-based: 0 = Jan
  const dayOfMonth = today.getDate();

  const todayStart = new Date(year, monthIndex, dayOfMonth, 0, 0, 0, 0);
  const todayEnd = new Date(year, monthIndex, dayOfMonth, 23, 59, 59, 999);

  const [startDate, setStartDate] = useState(todayStart);
  const [endDate, setEndDate] = useState(todayEnd);

  const startDateSet = (date) => {
    setStartDate(date);
  };

  const endDateSet = (date) => {
    setEndDate(date);
  };

  return (
    <ClientLayout>
      <div
        className="content-wrap body"
        style={{ marginLeft: "10px", marginRight: "10px", marginTop: "10px" }}
      >
        <div className="table-wrap">
          <div className="row">
            <div className="col-md-12">
              <div className="card" style={{ marginBottom: "9px" }}>
                <div className="card-header">
                  <i className="fa fa-align-justify"></i>
                  Report Filter
                </div>
                <div className="card-body">
                  <form
                    id="ReportFilterForm"
                    className="form-inline"
                    method="get"
                  >
                    <div
                      className="row"
                      style={{ textAlignLast: "justify", padding: "10px" }}
                    >
                      <div className="col-12 col-md-5">
                        <Bootstrap4DatePickerComponent
                          pickerId="ReportFrom"
                          inputId="DisplayFrom"
                          defaultDate={startDate}
                          setSelectedDate={startDateSet}
                        />
                      </div>
                      <strong style={{ margin: "auto" }}>&nbsp;-&nbsp;</strong>
                      <div className="col-12 col-md-5">
                        <Bootstrap4DatePickerComponent
                          pickerId="ReportTo"
                          inputId="DisplayTo"
                          defaultDate={endDate}
                          setSelectedDate={endDateSet}
                        />
                      </div>
                      <div className="form-group editsbmtbtn">
                        <label className="mx-1"> </label>
                        <button
                          className="btn btn-primary"
                          onClick={() => getProfitLoss()}
                          style={{
                            backgroundColor: "#00b181",
                            border: "none",
                            padding: "0.375rem 0.85rem"
                          }}
                          type="button"
                        >
                          <strong>Submit</strong>
                        </button>
                      </div>
                    </div>
                    <div className="row col-12"></div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="table-wrap" id="sportspl">
          <div className="card" style={{ marginBottom: "8px" }}>
            <div className="card-header">
              <i className="fa fa-align-justify"></i> Sports Profit Loss{" "}
              <b>({username}) </b>
            </div>

            <div className="card-body" style={{ padding: "14px" }}>
              <ul className="nav nav-pills">
                <li
                  className="nav-item"
                  style={{ display: cricektPL != 0 ? "" : "none" }}
                >
                  <a
                    className="nav-link Report-EventTypeId-new-frontPL"
                    onClick={() => getSportDetail(1, 1)}
                    style={{
                      color: "#00b181",
                      cursor: "pointer",
                      fontSize: "1rem"
                    }}
                  >
                    Cricket (
                    <span
                      style={{ color: cricektPL > 0 ? "#00b181" : "#00b181" }}
                    >
                      {formatTruncate(cricektPL)}
                    </span>
                    )
                  </a>
                </li>

                <li
                  className="nav-item plPadding"
                  style={{
                    display: fancyPL != 0 ? "" : "none",
                    paddingLeft: "10px"
                  }}
                >
                  <a
                    className="nav-link Report-EventTypeId-new-frontPL"
                    onClick={() => getSportDetail(1, 3)}
                    style={{
                      color: "#00b181",
                      cursor: "pointer",
                      paddingLeft: "10px"
                    }}
                  >
                    Fancy (
                    <span
                      style={{ color: fancyPL > 0 ? "#00b181" : "#00b181" }}
                    >
                      {formatTruncate(fancyPL)}
                    </span>
                    )
                  </a>
                </li>

                <li
                  className="nav-item plPadding"
                  style={{
                    display: soccerPL != 0 ? "" : "none"
                  }}
                >
                  <a
                    className="nav-link Report-EventTypeId-new-frontPL"
                    onClick={() => getSportDetail(2, 1)}
                    style={{ color: "#00b181", cursor: "pointer" }}
                  >
                    Soccer (
                    <span
                      style={{ color: soccerPL > 0 ? "#00b181" : "#00b181" }}
                    >
                      {formatTruncate(soccerPL)}
                    </span>
                    )
                  </a>
                </li>

                <li
                  className="nav-item plPadding"
                  style={{
                    display: tennisPL != 0 ? "" : "none"
                  }}
                >
                  <a
                    className="nav-link Report-EventTypeId-new-frontPL"
                    onClick={() => getSportDetail(3, 1)}
                    style={{ color: "#00b181", cursor: "pointer" }}
                  >
                    Tennis (
                    <span
                      style={{ color: tennisPL > 0 ? "#00b181" : "#00b181" }}
                    >
                      {formatTruncate(tennisPL)}
                    </span>
                    )
                  </a>
                </li>

                <li
                  className="nav-item plPadding"
                  style={{
                    display: horseRacePL != 0 ? "" : "none"
                  }}
                >
                  <a
                    className="nav-link Report-EventTypeId-new-frontPL"
                    onClick={() => getSportDetail(4, 1)}
                    style={{
                      color: "#00b181",
                      cursor: "pointer",
                      fontSize: "1rem"
                    }}
                  >
                    Horse Race (
                    <span
                      style={{ color: horseRacePL > 0 ? "#00b181" : "#00b181" }}
                    >
                      {formatTruncate(horseRacePL)}
                    </span>
                    )
                  </a>
                </li>

                <li
                  className="nav-item plPadding"
                  style={{
                    display: grayHoundPL != 0 ? "" : "none"
                  }}
                >
                  <a
                    className="nav-link Report-EventTypeId-new-frontPL"
                    onClick={() => getSportDetail(5, 1)}
                    style={{ color: "#00b181", cursor: "pointer" }}
                  >
                    Greyhound Race (
                    <span
                      style={{ color: grayHoundPL > 0 ? "#00b181" : "#00b181" }}
                    >
                      {formatTruncate(grayHoundPL)}
                    </span>
                    )
                  </a>
                </li>

                <li
                  className="nav-item plPadding"
                  style={{
                    display: worldCasinoPL != 0 ? "" : "none"
                  }}
                >
                  <a
                    className="nav-link Report-EventTypeId-new-frontPL"
                    onClick={() => getSportDetail(6, 1)}
                    style={{ color: "#00b181", cursor: "pointer" }}
                  >
                    Casino (
                    <span
                      style={{
                        color: worldCasinoPL > 0 ? "#00b181" : "#00b181"
                      }}
                    >
                      {formatTruncate(worldCasinoPL)}
                    </span>
                    )
                  </a>
                </li>

                <li
                  className="nav-item plPadding"
                  style={{
                    display: tpStudioPL != 0 ? "" : "none"
                  }}
                >
                  <a
                    className="nav-link Report-EventTypeId-new-frontPL"
                    onClick={() => getSportDetail(7, 1)}
                    style={{ color: "#00b181", cursor: "pointer" }}
                  >
                    TeenPatti Casino (
                    <span
                      style={{ color: tpStudioPL > 0 ? "#00b181" : "#00b181" }}
                    >
                      {formatTruncate(tpStudioPL)}
                    </span>
                    )
                  </a>
                </li>

                <li
                  className="nav-item plPadding"
                  style={{
                    display: betfairGamesPL != 0 ? "" : "none"
                  }}
                >
                  <a
                    className="nav-link Report-EventTypeId-new-frontPL"
                    onClick={() => getSportDetail(9, 1)}
                    style={{ color: "#00b181", cursor: "pointer" }}
                  >
                    Betfair Studio (
                    <span
                      style={{
                        color: betfairGamesPL > 0 ? "#00b181" : "#00b181"
                      }}
                    >
                      {formatTruncate(betfairGamesPL)}
                    </span>
                    )
                  </a>
                </li>

                <li
                  className="nav-item plPadding"
                  style={{
                    display: galexyStudioPL != 0 ? "" : "none"
                  }}
                >
                  <a
                    className="nav-link Report-EventTypeId-new-frontPL"
                    onClick={() => getSportDetail(10, 1)}
                    style={{ color: "#00b181", cursor: "pointer" }}
                  >
                    Galexy Studio (
                    <span
                      style={{
                        color: galexyStudioPL > 0 ? "#00b181" : "#00b181"
                      }}
                    >
                      {formatTruncate(galexyStudioPL)}
                    </span>
                    )
                  </a>
                </li>
              </ul>

              <div style={{ overflowY: "auto", width: "100%" }}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          textAlign: "right",
                          fontSize: "20px",
                          fontWeight: "normal"
                        }}
                      >
                        <div style={{ fontWeight: "normal" }}>
                          Total Amount :{" "}
                          <span
                            style={{
                              color: grandTotalPL > 0 ? "#000" : "#000"
                            }}
                          >
                            {formatTruncate(grandTotalPL)}
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="row" style={{ display: viewPLDetails ? "" : "none" }}>
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <i className="fa fa-align-justify"></i>
                  Account Ledger
                </div>

                <div className="card-body" style={{ padding: "4px" }}>
                  <div className="row">
                    <div className="col-sm-12">
                      <table
                        id="tableLedger"
                        className="table table-striped table-bordered dataTable no-footer dtr-inline"
                        role="grid"
                        aria-describedby="tableLedger_info"
                      >
                        <thead style={{ font: "caption" }}>
                          <tr role="row" style={{ backgroundColor: "#fff" }}>
                            <th
                              className="sorting"
                              tabindex="0"
                              aria-controls="tableLedger"
                              rowspan="1"
                              colspan="1"
                              aria-label="Match name: activate to sort column ascending"
                              style={{ width: isMobile ? "80px" : "170px" }}
                            >
                              Date
                            </th>

                            <th
                              className="sorting"
                              aria-controls="tableLedger"
                              tabindex="0"
                              rowspan="1"
                              colspan="1"
                              aria-label="Market Name: activate to sort column ascending"
                            >
                              {displayHeading}
                            </th>

                            <th
                              className="sorting"
                              aria-controls="tableLedger"
                              tabindex="0"
                              rowspan="1"
                              colspan="1"
                            >
                              Amount
                            </th>
                          </tr>
                        </thead>

                        <tbody style={{ backgroundColor: "#fff;" }}>
                          {profitLossList.map((item, idx) => (
                            <tr
                              style={{
                                backgroundColor:
                                  idx % 2 == 0 ? "#f2f2f2" : "#ffffff"
                              }}
                            >
                              <td
                                style={{
                                  fontSize: "16px",
                                  width: "25%",
                                  backgroundColor:
                                    idx % 2 == 0 ? "#f2f2f2" : "#ffffff"
                                }}
                              >
                                <span>
                                  {idx}-
                                  {moment
                                    .utc(item.created_date)
                                    .local()
                                    .format("DD/MM/YYYY hh:mm:ss A")}
                                </span>
                              </td>

                              <td
                                style={{
                                  fontSize: "16px",
                                  width: "50%",
                                  backgroundColor:
                                    idx % 2 == 0 ? "#f2f2f2" : "#ffffff"
                                }}
                              >
                                <a
                                  onClick={() => showBetDetails(item)}
                                  className="link_css"
                                  style={{ color: "#04b181" }}
                                >
                                  {showEventName(item.event_name)}{" "}
                                  {showDescription(item.market_type)}
                                </a>{" "}
                              </td>
                              <td
                                style={{
                                  fontSize: "16px",
                                  width: "25%",
                                  backgroundColor:
                                    idx % 2 == 0 ? "#f2f2f2" : "#ffffff"
                                }}
                              >
                                {formatTruncate(item.amount)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <style>{`
        .toggle-row {
          border: none;
          outline: none;
          cursor: pointer;
          width: 22px;
          height: 22px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          font-weight: 700;
          font-size: 16px;
          color: #fff;
          background-color: #28a745;
          margin-right: 6px;
        }
        .toggle-open { background-color: #dc3545 !important; }

        table.dataTable > tbody > tr > th, table.dataTable > tbody > tr > td {
          padding: 6px 9px;
      }
      `}</style>
        <style>{`
   
  @media screen and (max-width: 635px) {
    #ReportFilterForm .editsbmtbtn {
      margin: auto;
      margin-right: 15px;
    }
  }

  /* MOBILE ONLY FIXES */
  @media screen and (max-width: 640px) {
 
     
    #ReportFilterForm .editsbmtbtn {
      width: 100% !important;
      display: flex !important;
      justify-content: flex-end !important;
      align-items: center !important;
      margin-top: 0.5rem;
    }
    #ReportFilterForm .editsbmtbtn .btn {
      margin-right: 20px;
    } 

    .link_css {
      color: #04b181;
      text-decoration: none;
      font-size: 16px;
      cursor: pointer;
      white-space: pre-line;
      word-wrap:anywhere
    }
 
    }
`}</style>
      </div>
    </ClientLayout>
  );
};

export default ProfitLoss;
